export default "__VITE_ASSET__CkvtZ87k__"